<div class="deliverables-management-container p-0 container-fluid">
  <div class="sa-page-header-w-ip-wrapper">
    <h2 class="motif-h6-default-regular m-0 flexone">Deliverable Management</h2>
    <div class="btns-right d-flex">
      <button motifButton
        color="primary"
        size="small"
        (click)="addDeliverable()">
        <i class="pi pi-plus" aria-hidden="true"></i>
        Add Deliverable
      </button>
      <div class="motif-dropdown">
        <div
          motifDropdown
          [ngClass]="'placement-bottom'"
          [placement]="Placement.BOTTOM_RIGHT"
          [scrollStrategy]="ScrollStrategy.Reposition"
          [autoClose]="true"
          [closeOnBackdropClick]="true"
          [open]="false">
          <button motifButton
            color="secondary"
            size="small"
            motifDropdownToggle
            aria-label="Replicate Deliverable options"
            id="replicateDropdown"
            aria-controls="replicateDropdownMenu">
            <i class="pi pi-clone" aria-hidden="true"></i> Replicate Deliverable
          </button>
          <div
            motifDropdownMenu
            id="replicateDropdownMenu"
            aria-labelledby="replicateDropdown">
            <button motifDropdownItem (click)="openReplicateModal()">
              Compliance Calendar
            </button>
            <button motifDropdownItem (click)="openTransitionReplicateModal()">
              Transition
            </button>
          </div>
        </div>
      </div>
      <!-- <button motifButton color="secondary" aria-label="Filter deliverables">
          <i class="pi pi-filter" aria-hidden="true"></i>
      </button> -->
    </div>
  </div>

  <div class="deliverables-management-wrapper w-100">
    <app-deliverable-template> </app-deliverable-template>
  </div>
</div>
